import { PageContainer } from '@/components/ui/page-container';
import { PageHeader } from '@/components/ui/page-header';
import { FlowRetentionCard, VPN_FLOWS } from '@/features/vpnFlows';
import { DnsDomainsCard } from '../components/DnsDomainsCard';
import { PathSettingCard } from '../components/PathSettingCard';

/**
 * The organization's VPN settings, one card each (docs/VpnAccess.md, "Slice 6
 * design"); later settings join as cards of their own.
 */
export function VpnSettings() {
  return (
    <PageContainer width="medium">
      <PageHeader title="VPN settings" subtitle="How the VPN works across this organization" />
      <div className="space-y-6">
        <PathSettingCard />
        <DnsDomainsCard />
        {VPN_FLOWS ? <FlowRetentionCard /> : null}
      </div>
    </PageContainer>
  );
}
